module.exports = __webpack_public_path__ + "img/@awards_img_00.59b41ddc.jpg";